import UserItem from './UserItem'
import ChildVprTaskProgress from './ChildVprTaskProgress'
import { vprTaskProgressCacheSet } from './VprTask'

export default class ChildVpr {
  constructor (data) {
    if (!data || !data.id || !data.user_item) throw new Error('Invalid ChildVpr data.')

    this.id = data.id

    this.userItem = new UserItem(data.user_item, this)

    this.startworkProgress = {
      completed: data.startwork_progress?.completed ?? false,
      playerState: data.startwork_progress?.player_state ?? null
    }

    this.controlworksProgress = data.controlworks_progress
      ? data.controlworks_progress.map(cwProgressData => new ChildVprTaskProgress(cwProgressData, this))
      : []

    this.counters = {
      green: data.counters?.green || null,
      yellow: data.counters?.yellow || null,
      red: data.counters?.red || null
    }
  }

  get countTasks () {
    return this.userItem.vpr.countTasks
  }

  setStartworkProgress (playerState) {
    this.startworkProgress.playerState = playerState
    this.startworkProgress.completed = Boolean(playerState)
  }

  /**
   * @param  {ChildVprTaskProgress} taskProgress
   */
  setTaskProgress (taskProgress) {
    const targetIndex = this.controlworksProgress.findIndex(progress => progress.taskId === taskProgress.taskId)
    if (targetIndex !== -1) {
      this.controlworksProgress[targetIndex] = taskProgress
    } else {
      this.controlworksProgress.push(taskProgress)
    }

    // set this task progress is preloaded
    taskProgress.setPreloaded()

    // refresh task progress cache
    vprTaskProgressCacheSet(taskProgress.taskId, taskProgress)
  }
}
